import { gatewayInstance } from "../axiosInstance";
import { SERVICE_ENDPOINT } from "../const";

export const searchEmployeeModification = async (request) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/employee-modification/search`,
      request,
    );
    return response.data;
  } catch (error) {
    console.log("error get results", error);
    throw error;
  }
};

export const updateEmployeeDates = async (request, currentUser, companyId) => {
  try {
    const response = await gatewayInstance.put(
      `${SERVICE_ENDPOINT.TRANSPORT}/employee-modification/update-dates?currentUser=${currentUser}&companyId=${companyId}`,
      request,
    );
    return response.data;
  } catch (error) {
    console.log("error updating employee dates", error);
    throw error;
  }
};